<div matDialogTitle fxLayoutAlign="space-between start">
  <div>
    {{ data.name }}
  </div>
  <mat-icon matDialogClose style="cursor: pointer">close</mat-icon>
</div>
<div matDialogContent [innerHTML]="data.tooltipHtml | safe : 'html'"></div>
